// Color-coded label pill for similarity score.
// Thresholds: Best ≥ 60, Okay ≥ 30, Weak < 30
import { Flex, ProductColor, Typography } from '@aloft/toolkit-sui';

type SimilarityRating = 'Best' | 'Okay' | 'Weak';

const getSimilarityRating = (score: number): SimilarityRating => {
  if (score >= 60) return 'Best';
  if (score >= 30) return 'Okay';
  return 'Weak';
};

const RATING_STYLES: Record<
  SimilarityRating,
  { backgroundColor: ProductColor; color: ProductColor }
> = {
  Best: { backgroundColor: 'alertSuccessLight', color: 'textSuccess' },
  Okay: { backgroundColor: 'alertWarningLight', color: 'textWarning' },
  Weak: { backgroundColor: 'alertErrorLight', color: 'textError' },
};

type Props = {
  score: number;
};

export const SimilarityScorePill = ({ score }: Props) => {
  const rating = getSimilarityRating(score);
  const { backgroundColor, color } = RATING_STYLES[rating];

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      padding="4px 8px"
      borderRadius="20px"
      backgroundColor={backgroundColor}
      flexShrink={0}
      __dangerDoNotUseSx={{ display: 'inline-flex' }}
    >
      <Typography
        variant="body2"
        color={color}
        __dangerDoNotUseSx={{ fontWeight: 600, fontSize: '10px', whiteSpace: 'nowrap' }}
      >
        {rating}
      </Typography>
    </Flex>
  );
};
